// Apps (simple mode, D31): the Toolkits component in its simple variant, plus the
// one-time notice for a developer deep link that was redirected here.
import { DeveloperModeNotice } from '../components/DeveloperRoute'
import { ToolkitsView } from './ToolkitsView'

export function AppsView() {
  return (
    <>
      <DeveloperModeNotice />
      <ToolkitsView variant="simple" />
    </>
  )
}
